@if (element.data | removeBarEmptyCategories: false : categories | async; as widget) {
<app-mdr-title
    fontSize="16"
    class="dashboard-box-title d-flex m-b-20"
    >{{ element.title }}
    @if (widget.error) {
    <span class="ds-icon-error_outline fs-25 error-primary m-l-8 line-height-08"></span>
    }
</app-mdr-title>
@if (widget.data?.data) { @if (widget.data?.data.length && !widget.loading && !widget.hasNoResults) { @if (!invalidDataToShow &&
widget.data?.data) {
<section
    id="{{ element.id }}"
    [ngClass]="[tableLegend ? 'bar-chart-container' : '', !hasMarginTop ? 'm-t--15' : '']"
>
    <div class="m-l--15">
        <apx-chart
            #barChartRef
            [series]="convertStackedToSingleBar(widget.data?.data)"
            [chart]="stackedBarChartOptions.chart"
            [xaxis]="stackedBarChartOptions.xaxis"
            [yaxis]="stackedBarChartOptions.yaxis"
            [legend]="stackedBarChartOptions.legend"
            [fill]="stackedBarChartOptions.fill"
            [responsive]="stackedBarChartOptions.responsive"
            [plotOptions]="stackedBarChartOptions.plotOptions"
            [tooltip]="stackedBarChartOptions.tooltip"
            [dataLabels]="stackedBarChartOptions.dataLabels"
            [colors]="stackedBarChartOptions.colors"
            [states]="stackedBarChartOptions.states"
        ></apx-chart>
    </div>
    @if (tableLegend && showLegend) {
    <div class="bar-chart-right p-60">
        <app-mdr-dashboards-table
            [isChart]="true"
            [bulletType]="bulletType"
            [bottomBorder]="false"
            [displayedColumns]="legendDisplayedColumns"
        ></app-mdr-dashboards-table>
    </div>
    } @if (!tableLegend && showLegend) {
    <div
        class="chart-custom-legend p-lat-35"
        [ngClass]="hasMarginTop ? 'b-15 position-relative' : ''"
    >
        @for (category of calculateLegendTotal(widget.data?.data, element.colors, false); track category) {
        <div
            class="gz-data-item-legend"
            [ngClass]="scaleLegend ? 'm-r-40 auto-width' : ''"
        >
            @if (category.value) {
            <span
                [ngClass]="bulletType + '-bullet-legend'"
                [style.background]="category.color"
            ></span
            ><br />
            <div
                class="gz-data-item-legend--title text-ellipsis letter-spacing-0"
                #tooltip="matTooltip"
                [matTooltip]="category.name ? category.name : ''"
                matTooltipClass="mat-tooltip-custom"
                [matTooltipDisabled]="false"
                (mouseover)="checkInputClientVisibility($event, tooltip, '.gz-data-item-legend--title')"
            >
                {{ category.name }}:
            </div>
            <div class="gz-data-item-legend--value letter-spacing-0">
                {{ category.value }}
            </div>
            }
        </div>
        }
    </div>
    }
</section>

} } } @if (!widget.data?.data.length && !widget.loading) { @if (!invalidDataToShow) {
<div
    [ngClass]="[tableLegend ? 'bar-chart-container' : '', !showXaxisLabels ? 'b-15 position-relative' : '', !hasMarginTop ? 'm-t--15' : '']"
>
    <div class="m-l--15">
        <apx-chart
            #barChartRefEmpty
            id="{{ element.id }}"
            [series]="element.noDataSeries"
            [chart]="emptyStackedBarChartOptions.chart"
            [states]="emptyStackedBarChartOptions.states"
            [tooltip]="emptyStackedBarChartOptions.tooltip"
            [xaxis]="emptyStackedBarChartOptions.xaxis"
            [yaxis]="emptyStackedBarChartOptions.yaxis"
            [legend]="emptyStackedBarChartOptions.legend"
            [fill]="emptyStackedBarChartOptions.fill"
            [responsive]="emptyStackedBarChartOptions.responsive"
            [plotOptions]="emptyStackedBarChartOptions.plotOptions"
            [dataLabels]="emptyStackedBarChartOptions.dataLabels"
            [colors]="emptyStackedBarChartOptions.colors"
        ></apx-chart>
    </div>
    @if (tableLegend && showLegend) {
    <div class="bar-chart-right p-60">
        <app-mdr-dashboards-table
            [isChart]="true"
            [bulletType]="bulletType"
            [bottomBorder]="false"
            id="{{ element.id }}_legend"
            [displayedColumns]="legendDisplayedColumns"
        ></app-mdr-dashboards-table>
    </div>
    } @if (!tableLegend && showLegend) {
    <div
        class="chart-custom-legend m-l-15"
        id="{{ element.id }}_custom_legend"
        [ngClass]="hasMarginTop ? 'b-15 position-relative' : ''"
    >
        @for (category of calculateLegendTotal(element.noDataSeries, element.colors, true); track category) {
        <div
            class="gz-data-item-legend"
            [ngClass]="scaleLegend ? 'm-r-40 auto-width' : ''"
        >
            <span
                [ngClass]="bulletType + '-bullet-legend'"
                [style.background]="category.color"
            ></span
            ><br />
            <div
                class="gz-data-item-legend--title text-ellipsis"
                #tooltip="matTooltip"
                [matTooltip]="'test'"
                matTooltipClass="mat-tooltip-custom"
                [matTooltipDisabled]="disableTooltip"
                (mouseover)="checkInputClientVisibility($event, tooltip, 'span')"
            >
                <span>{{ category.name }}:</span>
            </div>
            <div class="gz-data-item-legend--value">{{ category.value }}</div>
        </div>
        }
    </div>
    }
</div>

} } @if (widget.data?.data && widget.hasNoResults) {
<app-empty-state
    i18n-title
    class="m-t-10"
    id="{{ element.id }}_no_results"
    title="{{ emptyText }}"
    type="noResults"
></app-empty-state>
} @if (widget.loading) {
<app-mdr-loader
    [ngClass]="widget.loading ? 'widget-empty' : 'widget-loading'"
    class="center-loader"
    [rows]="5"
    [columns]="1"
></app-mdr-loader>
} }
